/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["minuit","midi","mat.","après-midi","du soir","mat."],["minuit","midi","du mat.","après-midi","du soir","du mat."],["minuit","midi","du matin","de l’après-midi","du soir","du matin"]],[["minuit","midi","mat.","après-midi","du soir","mat."],["minuit","midi","mat.","après-midi","du soir","du mat."],["minuit","midi","matin","après-midi","soir","matin"]],["00:00","12:00",["04:00","12:00"],["12:00","18:00"],["18:00","24:00"],["00:00","04:00"]]];
